import _Cached from "@mui/icons-material/Cached";
import React from 'react';
import { COLORS } from '@fupa/fupa-uikit';
import ActivityHeader from 'app/components/district/common/ActivityHeader';
import { IconContainer } from 'app/components/district/common/ActivityStyles';
export default function TransferActivityHeader(_ref) {
  let {
    teamName,
    publishDate
  } = _ref;
  return /*#__PURE__*/React.createElement(ActivityHeader, {
    title: "Transfer",
    subject: teamName,
    publishDate: publishDate,
    "data-sentry-element": "ActivityHeader",
    "data-sentry-component": "TransferActivityHeader",
    "data-sentry-source-file": "TransferActivityHeader.tsx"
  }, /*#__PURE__*/React.createElement(IconContainer, {
    color: COLORS.orange,
    "data-sentry-element": "IconContainer",
    "data-sentry-source-file": "TransferActivityHeader.tsx"
  }, /*#__PURE__*/React.createElement(_Cached, {
    color: "icon-invert",
    fontSize: "inherit",
    "data-sentry-element": "Cached",
    "data-sentry-source-file": "TransferActivityHeader.tsx"
  })));
}